<template>
  <!--  <div v-show="false" class="no-gutters border rounded overflow-hidden mb-4 shadow-sm position-relative" style="padding: 20px;">-->
  <!--    <bar-chart :chart-data="chartData" :options="{ maintainAspectRatio: false }"></bar-chart>-->
  <!--  </div>-->
  <div class="page-container">
    <div class="row mb-2">
      <div class="col-md-4">
        <div
          class="row no-gutters border rounded overflow-hidden flex-md-row mb-4 shadow-sm h-md-250 position-relative"
        >
          <div class="col p-4 d-flex flex-column position-static">
            <strong class="d-inline-block mb-2 text-success"
              >Średni czas spędzony na stronie <font-awesome-icon icon="stopwatch"
            /></strong>
            <h3 class="mb-0" v-text="overall.avg_time"></h3>
            <div class="mb-1 text-muted">Statystyki sumaryczne</div>
            <p class="card-text mb-auto">W celu obejrzenia bardziej zaawansowanych statystyk.</p>
            <a href="#" class="stretched-link">Kliknij tutaj</a>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div
          class="row no-gutters border rounded overflow-hidden flex-md-row mb-4 shadow-sm h-md-250 position-relative"
        >
          <div class="col p-4 d-flex flex-column position-static">
            <strong class="d-inline-block mb-2 text-success"
              >Ilość udanych rejestracji <font-awesome-icon icon="calendar"
            /></strong>
            <h3 class="mb-0" v-text="overall.registrations_complete"></h3>
            <div class="mb-1 text-muted">Statystyki sumaryczne</div>
            <p class="mb-auto">W celu obejrzenia bardziej zaawansowanych statystyk.</p>
            <a href="#" class="stretched-link">Kliknij tutaj</a>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div
          class="row no-gutters border rounded overflow-hidden flex-md-row mb-4 shadow-sm h-md-250 position-relative"
        >
          <div class="col p-4 d-flex flex-column position-static">
            <strong class="d-inline-block mb-2 text-success"
              >Udział procentowy wizyt NFZ <font-awesome-icon icon="calendar"
            /></strong>
            <h3 class="mb-0" v-text="overallNfzPercentage"></h3>
            <div class="mb-1 text-muted">Statystyki sumaryczne</div>
            <p class="mb-auto">W celu obejrzenia bardziej zaawansowanych statystyk.</p>
            <a href="#" class="stretched-link">Kliknij tutaj</a>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div
          class="row no-gutters border rounded overflow-hidden flex-md-row mb-4 shadow-sm h-md-250 position-relative"
        >
          <div class="col p-4 d-flex flex-column position-static">
            <strong class="d-inline-block mb-2 text-danger"
              >Procent niepotwierdzonych wizyt <font-awesome-icon icon="hourglass-end"
            /></strong>
            <h3 class="mb-0" v-text="overallUnconfirmedPercentage"></h3>
            <div class="mb-1 text-muted">Statystyki sumaryczne</div>
            <p class="mb-auto">W celu obejrzenia bardziej zaawansowanych statystyk.</p>
            <a href="#" class="stretched-link">Kliknij tutaj</a>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div
          class="row no-gutters border rounded overflow-hidden flex-md-row mb-4 shadow-sm h-md-250 position-relative"
        >
          <div class="col p-4 d-flex flex-column position-static">
            <strong class="d-inline-block mb-2 text-danger"
              >Procent wizyt, przy których wystąpił błąd
              <font-awesome-icon icon="exclamation-circle"
            /></strong>
            <h3 class="mb-0" v-text="overallFailedPercentage"></h3>
            <div class="mb-1 text-muted">Statystyki sumaryczne</div>
            <p class="mb-auto">W celu obejrzenia bardziej zaawansowanych statystyk.</p>
            <a href="#" class="stretched-link">Kliknij tutaj</a>
          </div>
        </div>
      </div>
    </div>

    <!--    <h2>Ostatnio zarejestrowane</h2>-->
    <!--    <div class="table-responsive">-->
    <!--      <table class="table table-striped table-sm">-->
    <!--        <thead>-->
    <!--        <tr>-->
    <!--          <th>#</th>-->
    <!--          <th>Header</th>-->
    <!--          <th>Header</th>-->
    <!--          <th>Header</th>-->
    <!--          <th>Header</th>-->
    <!--        </tr>-->
    <!--        </thead>-->
    <!--        <tbody>-->
    <!--        <tr>-->
    <!--          <td>1,001</td>-->
    <!--          <td>Lorem</td>-->
    <!--          <td>ipsum</td>-->
    <!--          <td>dolor</td>-->
    <!--          <td>sit</td>-->
    <!--        </tr>-->
    <!--        </tbody>-->
    <!--      </table>-->
    <!--    </div>-->
  </div>
</template>

<script>
export default {
  mounted() {
    const vm = this
    vm.fetchStatistics()
  },
  props: ['scope'],
  methods: {
    fetchStatistics() {
      const vm = this
      vm.$store.commit('addPageLoaderEvent', 'fetchStatistics')
      vm.$http
        .post('auth/get', { type: 'overall', api_key: vm.scope })
        .then(response => {
          vm.statistics.overall.push(response.data)
        })
        .catch(e => {
          console.error(e)
        })
        .then(() => {
          vm.$store.commit('removePageLoaderEvent', 'fetchStatistics')
        })
    }
  },
  watch: {
    scope() {
      this.fetchStatistics()
    }
  },
  computed: {
    overall() {
      const vm = this
      let scope
      if ((scope = vm.statistics.overall.find(v => v.scope === vm.scope)) === undefined) {
        scope = {
          avg_time: '00:00:00',
          registrations_complete: 0,
          registrations_failed: 0,
          registrations_nfz: 0,
          registrations_private: 0,
          registrations_unconfirmed: 0
        }
      }
      return scope
    },
    overallUnconfirmedPercentage() {
      const sum =
        this.overall.registrations_complete +
        this.overall.registrations_failed +
        this.overall.registrations_unconfirmed
      if (sum === 0) return '0%'
      const percentage = (this.overall.registrations_unconfirmed / sum) * 100
      return `${percentage.toFixed(2)}%`
    },
    overallFailedPercentage() {
      const sum =
        this.overall.registrations_complete +
        this.overall.registrations_failed +
        this.overall.registrations_unconfirmed
      if (sum === 0) return '0%'
      const percentage = (this.overall.registrations_failed / sum) * 100
      return `${percentage.toFixed(2)}%`
    },
    overallNfzPercentage() {
      const sum = this.overall.registrations_nfz + this.overall.registrations_private
      if (sum === 0) return '0%'
      const percentage = (this.overall.registrations_nfz / sum) * 100
      return `${percentage.toFixed(2)}%`
    }
  },
  data() {
    return {
      statistics: {
        overall: []
      }
    }
  }
}
</script>

<style scoped></style>
